import { render, staticRenderFns } from "./EditPartsDialog.vue?vue&type=template&id=a5a992aa&"
import script from "./EditPartsDialog.vue?vue&type=script&lang=js&"
export * from "./EditPartsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports